import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import CardView from "../../../../components/common/CardView";
import FileUpload from "../../../../components/common/FileUpload";
import { Button, dialog } from "nq-component";
import InputRow from "../../my-component/InputRow";
import PerformanceTable from "../../my-component/PerformanceTable";
import OPCRFormPresenter from "./OPCRFormPresenter";
import { DatePicker, Space } from "antd";
import InputFactory from "../../../../components/InputFactory";
import dayjs from "dayjs";

class ViewOPCRForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      periodFrom: "2021-07-01",
      periodTo: "2021-12-31",
      addRow: false,
      unitoutcome: "",
      successindicators: "",
      allottedbudget: "",
      // individualsaccountable: "",
      actualaccomplishments: "",
      quality: "",
      efficiency: "",
      timeliness: "",
      remarks: "",
      ipcrForm: [],
      isRating: false,
      object: {},
      indexToEdit: null,
      searchTerm: "",
      rating: ["Quality", "Efficiency", "Timeliness"],
      inputField: [
        "Unit Outcome",
        "Success Indicators",
        "Allotted Budget",
        // "Individuals Accountable",
        "Actual Accomplishments",
      ],
      assignedEmployee: {},
      findEmp: [],
    };
    this.presenter = new OPCRFormPresenter(
      this,
      findObjectUseCase(),
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  handleRatingClick() {
    this.setState((prevState) => ({ isRating: !prevState.isRating }));
  }

  getCollectionName() {
    return "opcr";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const params = this.getParams().id;
    const primaryObject = this.state;
    console.log("ppp", primaryObject);
    const update = primaryObject;
    const objectArray = Array.isArray(update.object)
      ? update.object
      : [update.object];
    const filteredObject = objectArray.filter((item) => item.id === params);
    console.log("qq:", filteredObject);

    const query = {
      where: {
        id: params,
      },
      include: ["all"],
    };
    const find = await findObjectUseCase().execute("opcr", query);
    this.setState({ findEmp: find });

    console.log("findsss", find);
  }

  componentDidUpdate(prevProps, prevState) {
    const { object, indexToEdit, ipcrForm } = this.state;
    if (prevState.object !== object && indexToEdit !== null) {
      const getObject = ipcrForm[indexToEdit];
      if (getObject) {
        this.setState({
          unitoutcome: getObject.unitoutcome,
          successindicators: getObject.successindicators,
          allottedbudget: getObject.allottedbudget,
          // individualsaccountable: getObject.individualsaccountable,
          actualaccomplishments: getObject.actualaccomplishments,
          quality: getObject.quality,
          efficiency: getObject.efficiency,
          timeliness: getObject.timeliness,
          remarks: getObject.remarks,
        });
      }
    }

    if (prevState.object !== this.state.object) {
      if (this.state.object.length > 0) {
        const object = this?.state?.object?.find(
          (item) => item.id === this.getObjectId()
        );
        this.setState({
          ipcrForm: object.performance,
          selectedFiles: object.selectedFiles,
          modifyFiles: object.modifyFiles,
          periodFrom: object.periodFrom,
          periodTo: object.periodTo,
        });
      }
    }
  }

  handleAddRow() {
    this.setState({
      unitoutcome: "",
      successindicators: "",
      allottedbudget: "",
      // individualsaccountable: "",
      actualaccomplishments: "",
      quality: "",
      efficiency: "",
      timeliness: "",
      remarks: "",
      addRow: true,
      indexToEdit: null,
      object: {},
      selectedFiles: [],
      modifyFiles: [],
    });
  }

  handleCloseRow() {
    this.setState({ addRow: false });
  }

  handleChange(field, value) {
    this.setState({ [field]: value });
  }

  handleRatingChange(field, value) {
    const regex = /^(\d{0,1}(\.\d{0,2})?)?$/;
    if (!regex.test(value)) {
      value = "";
    } else if (parseFloat(value) > 5) {
      value = "5";
    }
    this.setState({ [field]: value });
  }

  handleRemarksChange(remarks) {
    this.setState({ remarks });
  }

  handleAddData() {
    const primaryObject = this.state;

    const average =
      (parseFloat(primaryObject.quality) +
        parseFloat(primaryObject.efficiency) +
        parseFloat(primaryObject.timeliness)) /
      3;
    const data = {
      unitoutcome: primaryObject.unitoutcome,
      successindicators: primaryObject.successindicators,
      allottedbudget: primaryObject.allottedbudget,
      // individualsaccountable: primaryObject.individualsaccountable,
      actualaccomplishments: primaryObject.actualaccomplishments,
      quality: primaryObject.quality,
      efficiency: primaryObject.efficiency,
      timeliness: primaryObject.timeliness,
      average,
      remarks: primaryObject.remarks,
    };

    if (primaryObject.indexToEdit !== null) {
      const updatedForm = primaryObject.ipcrForm.map((item, index) =>
        index === primaryObject.indexToEdit ? data : item
      );
      this.setState({
        ipcrForm: updatedForm,
        addRow: false,
        indexToEdit: null,
      });
    } else {
      this.setState((prevState) => ({
        ipcrForm: [...prevState.ipcrForm, data],
        addRow: false,
      }));
    }
  }

  handleTrashData(indexToRemove) {
    const removedItem = this.state.ipcrForm.filter(
      (_, index) => index !== indexToRemove
    );
    this.setState({ ipcrForm: removedItem });
  }

  handleEditData(object, indexToEdit) {
    this.setState({
      object,
      indexToEdit,
      addRow: true,
      unitoutcome: object.unitoutcome,
      successindicators: object.successindicators,
      allottedbudget: object.allottedbudget,
      // individualsaccountable: object.individualsaccountable,
      actualaccomplishments: object.actualaccomplishments,
      quality: object.quality,
      efficiency: object.efficiency,
      timeliness: object.timeliness,
      remarks: object.remarks,
    });
  }

  handleSearch(event) {
    this.setState({ searchTerm: event.target.value });
  }

  // changeFile
  handleFileChange(selectedFiles) {
    this.setState({ selectedFiles });
  }

  handleFileChange2(modifyFiles) {
    this.setState({ modifyFiles });
  }

  onChange(value, field) {
    console.log({ [field]: value });
    this.setState({ [field]: value });
    // this.presenter.onChange(value, field);
  }

  render() {
    const primaryObject = this.state;
    const isMobile = window.innerWidth <= 768;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    const params = this.getParams().id;
    console.log("pp", params);
    const update = primaryObject;

    console.log("update", update);
    const objectArray = Array.isArray(update.object)
      ? update.object
      : [update.object];
    const filteredObject = objectArray.filter((item) => item.id === params);
    console.log("Filtered Object:", filteredObject);
    const { RangePicker } = DatePicker;
    if (!schema) return <h1>No schema</h1>;

    const filteredIpcrForm = primaryObject.ipcrForm.filter((item) =>
      Object.values(item).some((val) =>
        val
          .toString()
          .toLowerCase()
          .includes(primaryObject.searchTerm.toLowerCase())
      )
    );

    const fields = [
      ...primaryObject.inputField,
      ...primaryObject.rating,
      "average",
      "remarks",
    ].map((field) => field.replace(" ", "").toLowerCase());

    // console.warn("FIELD:", fields);

    return (
      <>
        <div className="overflow-auto mt-5">
          <div className={`h-100 ${isMobile ? "p-2" : "p-5"}`}>
            <CardView style={{ borderRadius: 0, padding: 0 }}>
              <div>
                <h6 className="ps-4 pt-4">
                  <b>OFFICE PERFORMANCE COMMITMENT AND REVIEW (OPCR)</b>
                </h6>
                <hr />
              </div>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.presenter.handleFormSubmit();
                }}
                className="d-grid"
              >
                <div className="ps-3 pe-3 pb-4">
                  <label>
                    Period <span className="text-danger">*</span>
                  </label>
                  <br />
                  <Space direction="vertical" size={20}>
                    <RangePicker
                      required
                      value={
                        this.state.periodFrom && this.state.periodTo
                          ? [
                              dayjs(this.state.periodFrom),
                              dayjs(this.state.periodTo),
                            ]
                          : null
                      }
                      disabled
                      onChange={(date, value) =>
                        this.setState({
                          periodFrom: value[0],
                          periodTo: value[1],
                        })
                      }
                      className="custom-range-picker border p-2 fw-semibold"
                    />
                  </Space>
                  <div className="mt-2">
                    <label>
                      Employee <span className="text-danger">*</span>
                    </label>
                    <InputFactory
                      className="col-6"
                      type="Pointer"
                      // defaultValue={filteredObject[0]?.assignedEmployee}
                      defaultValue={this.state.findEmp[0]?.assignedEmployee}
                      field="assignedEmployee"
                      target="employees"
                      disabled
                      onChange={this.onChange.bind(this)}
                      placeholder="Select Employee"
                    />
                  </div>

                  <div className="border mt-4 p-0">
                    <div className="row pt-2 ps-2 pe-2 pb-0 m-0">
                      <div className="d-grid col-lg-6">
                        {[5, 4, 3, 2, 1].map((score, index) => (
                          <span key={index}>
                            {score} -{" "}
                            {
                              [
                                "Outstanding",
                                "Very Satisfactory",
                                "Satisfactory",
                                "Unsatisfactory",
                                "Poor",
                              ][index]
                            }
                          </span>
                        ))}
                      </div>
                      <div className="col-lg-6 d-flex align-items-end gap-3">
                        <input
                          type="search"
                          className="form-control rounded ps-5"
                          placeholder="Search"
                          disabled
                          onChange={this.handleSearch.bind(this)}
                        />
                        <button
                          type="button"
                          className="btn btn-primary w-25"
                          onClick={this.handleAddRow.bind(this)}
                          disabled
                        >
                          <i className="bi bi-plus-lg" /> {schema.collection}
                        </button>
                      </div>
                      <div className="pt-1 ps-1 pe-1 pb-0">
                        <PerformanceTable
                          tableHeader={[
                            "#",
                            "Unit Outcome",
                            "(Targets + Measures)",
                            "Allotted Budget",
                            // "Individuals Accountable",
                            "Actual Accomplishments",
                            "Q1",
                            "E2",
                            "T3",
                            "A4",
                            "Remarks",
                            "Actions",
                          ]}
                          formulaHeader={[
                            "",
                            "",
                            "",
                            "",
                            "",
                            "(h)",
                            "(i)",
                            "(j)",
                            "(k = ave of h, i, j)",
                            "(m)",
                            "",
                          ]}
                          tableBody={fields}
                          object={filteredIpcrForm}
                          handleRatingClick={this.handleRatingClick.bind(this)}
                          isRating={this.state.isRating}
                          disabled={true}
                          handleTrashData={this.handleTrashData.bind(this)}
                          handleEditData={this.handleEditData.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row d-flex align-items-center p-3">
                    <div
                      className="col-lg-1 border"
                      style={{ height: "1px" }}
                    />
                    <span className="col-lg-2 text-center">
                      <i className="bi bi-file-earmark" /> Attachments
                    </span>
                    <div
                      className="col-lg-9 border"
                      style={{ height: "1px" }}
                    />

                    <div className="col-lg-12 mt-5">
                      <FileUpload
                        label={"Upload Employee's Documents"}
                        attachments={this.state.selectedFiles}
                        onFileChange={this.handleFileChange.bind(this)}
                        disabled
                      />
                    </div>
                    {filteredObject[0]?.stats === "Pending" && (
                      <div className="col-lg-12 mt-5">
                        <FileUpload
                          label={"Upload Employee's Documents"}
                          attachments={this.state.modifyFiles}
                          onFileChange={this.handleFileChange2.bind(this)}
                          disabled
                        />
                      </div>
                    )}
                  </div>
                </div>
                <hr />
                <div className="mb-4 ms-auto pe-4">
                  <button
                    type="button"
                    className="btn btn-light fs-sm me-3"
                    onClick={this.onClickBack.bind(this)}
                  >
                    Cancel
                  </button>
                  {/* <button type="submit" className="btn btn-primary fs-sm">
                    <i className="bi bi-file-earmark-check me-2"></i>
                    {label}
                  </button> */}
                </div>
              </form>
            </CardView>
          </div>
        </div>

        {primaryObject.addRow && (
          <InputRow
            ratings={primaryObject.rating}
            inputField={primaryObject.inputField}
            handleRatingClick={this.handleRatingClick.bind(this)}
            handleAddData={this.handleAddData.bind(this)}
            handleCloseRow={this.handleCloseRow.bind(this)}
            handleRemarksChange={this.handleRemarksChange.bind(this)}
            handleChange={this.handleChange.bind(this)}
            handleRatingChange={this.handleRatingChange.bind(this)}
            primaryObject={primaryObject}
          />
        )}
      </>
    );
  }
}

export default withRouter(ViewOPCRForm);
